export function normalizeCaseNumbers(caseNumberValue) {
  if (Array.isArray(caseNumberValue)) {
    return caseNumberValue
      .filter((caseNumber) => caseNumber !== undefined && caseNumber !== null)
      .map(String)
      .map((caseNumber) => caseNumber.trim())
      .filter(Boolean);
  }

  if (caseNumberValue === undefined || caseNumberValue === null) {
    return [];
  }

  const caseNumber = String(caseNumberValue).trim();
  return caseNumber ? [caseNumber] : [];
}

export function encodeCaseNumberForPath(caseNumber) {
  return String(caseNumber || "").trim().replace(/\//g, "-");
}

export function decodeCaseNumberFromPath(slug) {
  const value = String(slug || "").trim();

  if (/^\d{4}-v\d/i.test(value)) {
    return value.replace(/^(\d{4})-/i, "$1/");
  }

  return value.replace(/-(\d{4})([-]|$)/, "/$1$2");
}
